import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import SEO from '../components/SEO'

export default function BlogPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <SEO title="Blog" description="Updates, announcements, and writing tips from the Verse team." />
      <Navbar />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
        padding: '40px 24px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: 20 }}>📝</div>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--text)', margin: '0 0 12px' }}>
          Blog — Coming Soon
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--text-muted)', maxWidth: 480, lineHeight: 1.7, margin: '0 0 32px' }}>
          Updates, announcements, and writing tips from the Verse team. Check back soon.
        </p>
        <Link to="/" className="btn btn-primary">Back to home</Link>
      </div>
    </div>
  )
}
